import { render } from "./VentaMetodoPago.vue?vue&type=template&id=1708eb7a&scoped=true"
import script from "./VentaMetodoPago.vue?vue&type=script&lang=js"
export * from "./VentaMetodoPago.vue?vue&type=script&lang=js"

import "./VentaMetodoPago.vue?vue&type=style&index=0&id=1708eb7a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\rotcen_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1708eb7a"]])

export default __exports__